import React from 'react'
import { makeStyles } from '@material-ui/core'
import SocialNetworkLinks from './social-network-icons/social-network-icons'
import { getLogoSrc } from '../../../../utils/utils'
import { useSelector } from 'react-redux'

const FooterTop = () => {
  const brand = useSelector((state) => state.reducer.brand)

  const useStyles = makeStyles((theme) => ({
    footerTop: {
      borderBottom: `1px solid ${theme.palette.footer.icons}`,
      height: 95,
      padding: theme.spacing(0, 2, 2, 2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        height: 120,
        flexDirection: 'column',
        gap: theme.spacing(1),
      },
    },
    logoFooter: {
      maxHeight: brand?.imageLogos.needBigLogos ? 'auto' : 45,
      [theme.breakpoints.down('md')]: {
        maxHeight: brand?.imageLogos.needBigLogos ? 'auto' : 32,
        height: brand?.imageLogos.needBigLogos ? 60 : 'auto',
      },
      height: brand?.imageLogos.needBigLogos ? 80 : 'auto',
    }
  }))
  const classes = useStyles()
  const logoSrc = getLogoSrc(brand?.imageLogos?.logoFooter)
  return (
    <div className={classes.footerTop}>
      {logoSrc && <img id='logo' alt='' src={logoSrc} className={classes.logoFooter} />}
      <SocialNetworkLinks />
    </div>
  )
}

export default FooterTop
